import { gql } from '@apollo/client';

export const OBJECTIVE_ITEM_FRAGMENT = gql`
  fragment ObjectiveItem on FacebookPostTotalExpensesObjectiveItem {
    budget
    currency
  }
`;
